import { Auftrag, Warenuebernahme } from './warenuebernahme';
import { ArtikelMenge, Einheit } from './artikel';
import { Palette } from './direkte-einlagerung';
import { PaletteBean } from './pallet-item';

export interface Bewelg {
  id: number;
  idbewe: number;
  chargennummer: string | null;
  einheit_lf: Einheit;
  einheit_lg: Einheit;
  gewicht: number;
  lagerplatz: object | null;
  lagmenge: number;
  liefmenge: number;
  liefmenge_offen: number;
  mhd: string | null;
  palette: unknown | null;
  status: 'O' | 'E';
}

/** The Mengen-Eingabe shows liefmenge_offen; submit that as liefmenge. */
export function withOpenQuantityAsDelivered(bewelg: Bewelg): Bewelg {
  return { ...bewelg, liefmenge: bewelg.liefmenge_offen };
}

export interface Bewe {
  id: number;
  artikelMenge: ArtikelMenge;
  idarteheingabe?: number;
  lfdnr: number;
  zeilentext?: string;
  auftrag?: Auftrag;
  lagerplatz: string;
  status: 'O' | 'E'; // "A" im Frontend = beide anzeigen
  anzahlPalette?: number;
  anzahlPalettenSoll?: number;
  anzahlPalettenMin?: number;
  sollMenge?: number;
  bestellnummer?: string;
  paletten?: {
    sscc: string;
    extref?: string;
  }[];
  idReklamation?: number | string;
  bewelgs?: Bewelg[];
  einheitenEingabeErlaubt: boolean;
  idlagerstamm?: number;
  dimension?: BeweDimension;
  dimensionen?: BeweDimension[];
}

export interface BeweDimension {
  id?: number;
  massUnitId?: string; // "Länge (cm) *  Stärke (cm) * Breite (cm)",
  height?: number; // number
  width?: number;
  depth?: number;
  menge?: number;
}

// splittung (amounts) for the default backend, paletten (PaletteBean) with palletDetailFlow (bolay)
export type PositionErledigenSplit = { splittung: number[] } | { paletten: PaletteBean[] };

export interface WarenuebernahmeBeweEtikett {
  bewegung: Bewe;
  anzahlEtiketten: number;
  splittung?: number[];
  paletten?: PaletteBean[];
}

export interface PositionErledigenParams {
  warenuebernahme: Warenuebernahme;
  payload: WarenuebernahmeBeweEtikett;
}

export interface PositionErledigenMischPaletteParams {
  warenuebernahme: Warenuebernahme;
  payload: {
    bewegung: Bewe;
    palette: Palette;
    splittung?: number[];
    bewelg?: Bewelg;
  };
}
